const o = {
  id: "TexasTwoStep",
  name: "Two Step",
  style: {
    colorPrimary: "#004199",
    extraBall: {
      bg: "#004199",
      color: "#ffffff"
    }
  }
};
export {
  o as default
};
